import { defaultAgentPhoto } from "../assets";

const selectAvatarUrl = contact => {
  const imageUrl = contact?.image?.url;
  const headshotUrl = contact?.industry_professional?.headshot?.url;

  return headshotUrl || imageUrl;
};

const getAvatarSrc = contact => selectAvatarUrl(contact) || defaultAgentPhoto;

export default getAvatarSrc;
